import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

/** Fade-and-rise scroll reveal for whole sections. */
export const Reveal = ({ children, delay = 0, y = 36, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

/** Masked line reveal — text slides up from behind an overflow mask. */
export const MaskedLine = ({ children, delay = 0, className = "", as: Tag = "span", ...props }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      initial={{ y: "115%" }}
      whileInView={{ y: "0%" }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1, delay, ease: EASE }}
      className="block will-change-transform"
      {...props}
    >
      {children}
    </motion.span>
  </span>
);
